<template>
  <FollowupV7SingleCta
    v-if="layout === 'cta'"
    :question="question"
    :disabled="disabled"
    @choose="choose"
  />
  <FollowupV7SingleCircle
    v-else-if="layout === 'circle'"
    :question="question"
    :selected-id="answer"
    :disabled="disabled"
    @choose="choose"
  />
  <FollowupV7SingleStack
    v-else
    :question="question"
    :selected-id="answer"
    :disabled="disabled"
    @choose="choose"
  />
</template>

<script>
/**
 * Renders an `answertype: 'single'` follow-up question.
 *
 * A thin dispatcher: picks the visual sub-layout from `question.displaymode`
 * ('cta' | 'circle' | 'stack') and delegates rendering to the matching
 * sub-component in `./single/`. The preview fixture already carries the mode
 * (src/playground/follow-up/v7/questions.fixture.js) and the BE will supply it on the live flow later.
 * Any question without a valid `displaymode` falls back to 'stack'.
 *
 * Selection state is held here (single source of truth) and passed down as
 * `selectedId` so an inline (composite) follow-up can render below this
 * component while the chosen option stays highlighted.
 */
import FollowupV7SingleCta from '@/components/followup/v7/single/cta.vue';
import FollowupV7SingleCircle from '@/components/followup/v7/single/circle.vue';
import FollowupV7SingleStack from '@/components/followup/v7/single/stack.vue';

export default {
  name: 'FollowupV7Single',

  components: {
    FollowupV7SingleCta,
    FollowupV7SingleCircle,
    FollowupV7SingleStack,
  },

  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      answer: null,
    };
  },

  computed: {
    layout() {
      const mode = this.question.displaymode;
      return ['cta', 'circle', 'stack'].includes(mode) ? mode : 'stack';
    },
  },

  watch: {
    question: {
      handler() {
        this.answer = this.question.answer ?? null;
      },
      deep: true,
    },
  },

  mounted() {
    if (this.question.answer != null) {
      this.answer = this.question.answer;
    }
  },

  methods: {
    choose(opt) {
      this.answer = opt.id;
      this.$emit('submitAnswer', this.question.id, opt.id, opt);
    },
  },
};
</script>
